import { createSlice } from '@reduxjs/toolkit';
export const configInitialState = {
    partnerId: undefined,
    alexMode: undefined,
};
const configSlice = createSlice({
    name: 'config',
    initialState: configInitialState,
    reducers: {},
});
export default configSlice.reducer;
export const configSelector = (state) => state.config;
//# sourceMappingURL=config.js.map